/* eslint-disable */
var baseApiUrl = ''
var appBaseUrl = ''
if (process.env.NODE_ENV === 'production') {
  // baseApiUrl = 'https://discussion-tool-demo-api.geodemosolutions.com/public/'
  // appBaseUrl = 'https://discussion-tool-demo.geodemosolutions.com/#/'
  baseApiUrl = 'https://gwhu-collaboration-tool-api.geodemosolutions.com/public/'
  appBaseUrl = 'https://gwhu-collaboration-tool.geodemosolutions.com/#/'
 }
else {
  baseApiUrl = 'http://localhost/discussion-tool-api/public/'
  appBaseUrl = 'http://localhost:7800/#/'
}

export {
  baseApiUrl,
  appBaseUrl
}
